var ArchivioEdizioni = (function () {

  var projects_data = {};
  var $container;
  var currentView = 'grid';


  // ── HTML escape utility ──
  function escHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }


  // ── Render tile-gallery grid (progetti / contributi) ──
  function renderTileGrid(post) {
    var sizeMap = {
      'small-square': 'small',
      'rect-oriz':    'horizontal',
      'rect-vert':    'vertical',
      'big-square':   'big'
    };
    var size = sizeMap[post.tile_size] || 'small';

    var imgHtml = post.tile_thumb_url
      ? '<img class="bg" src="' + post.tile_thumb_url + '" alt="" loading="lazy">'
      : '';

    var authorHtml = '';
    if (post.nome_promotore) {
      authorHtml = '<p class="author">' + escHtml(post.nome_promotore) + '</p>';
    } else if (post.contributo_nome) {
      var authorName = (post.contributo_nome + ' ' + (post.contributo_cognome || '')).trim();
      if (authorName) {
        authorHtml = '<p class="author">' + escHtml(authorName) + '</p>';
      }
    }

    var tagsHtml = '<div class="tags">' +
      '<span comp="tags" class="--light"><span>' + escHtml(post.tipo_di_post) + '</span></span>' +
      '</div>';

    var linkAttrs = '';
    var href = post.permalink;
    if (post.tipo_di_post === 'contributi') {
      if (post.contributo_video) {
        href = post.contributo_video;
        linkAttrs = ' data-fancybox=""';
      } else {
        href = 'javascript:;';
        linkAttrs = ' data-fancybox="" data-src="#contributo-' + post.id + '"';
      }
    }

    return '<a comp="tile-gallery" class="--grid --' + size + '" href="' + href + '"' + linkAttrs + '>' +
      imgHtml +
      '<div class="tile">' +
        '<div class="content">' +
          '<div class="card">' +
            '<div class="card-text">' +
              authorHtml +
              '<p class="title">' + escHtml(post.title) + '</p>' +
            '</div>' +
            '<span comp="button" class="--secondary"><span class="label">Scopri</span><span class="underline"></span></span>' +
          '</div>' +
        '</div>' +
        tagsHtml +
      '</div>' +
    '</a>';
  }


  // ── Render tile-eventi (eventi) ──
  function renderTileEvento(post) {
    var bgColor = '';
    var classes = post.tile_classes || '';
    var sedeMap = {
      'sede-evento-venezia': 'var(--alfa)',
      'sede-evento-torino':  'var(--beta)',
      'sede-evento-milano':  'var(--gamma)',
      'sede-evento-milano-social': 'var(--beta)',
      'sede-evento-urbanpromo-digital': 'var(--delta)',
      'sede-evento-urbanpromo-letture': 'var(--epsilon)',
      'sede-evento-urbanpromo-presenta': 'var(--zeta)'
    };
    for (var sede in sedeMap) {
      if (classes.indexOf(sede) !== -1) {
        bgColor = sedeMap[sede];
        break;
      }
    }
    var styleAttr = bgColor ? ' style="--tile-bg: ' + bgColor + '"' : '';

    var subtitleHtml = post.ente_curatore
      ? '<p class="subtitle">' + escHtml(post.ente_curatore) + '</p>'
      : '';

    var tagsItems = [];
    if (post.sala_evento) tagsItems.push(post.sala_evento);
    if (post.giorno_evento) tagsItems.push(post.giorno_evento);
    if (post.inizio_evento && post.fine_evento) {
      tagsItems.push(post.inizio_evento + '/' + post.fine_evento);
    }
    var tagsHtml = '';
    if (tagsItems.length) {
      tagsHtml = '<div class="tags">';
      for (var t = 0; t < tagsItems.length; t++) {
        tagsHtml += '<span comp="tags" class="--light"><span>' + escHtml(tagsItems[t]) + '</span></span>';
      }
      tagsHtml += '</div>';
    }

    return '<a comp="tile-eventi" class=""' + styleAttr + ' href="' + post.permalink + '">' +
      '<div class="overlay">' +
        '<div class="text-card">' +
          '<div class="text">' +
            subtitleHtml +
            '<p class="title">' + escHtml(post.title) + '</p>' +
          '</div>' +
          '<span comp="button" class="--secondary"><span class="label">Scopri</span><span class="underline"></span></span>' +
        '</div>' +
        tagsHtml +
      '</div>' +
    '</a>';
  }


  // ── Render tile-gallery list (all post types) ──
  function renderTileList(post) {
    var authorHtml = '';
    if (post.nome_promotore) {
      authorHtml = '<p class="author">' + escHtml(post.nome_promotore) + '</p>';
    } else if (post.contributo_nome) {
      var name = (post.contributo_nome + ' ' + (post.contributo_cognome || '')).trim();
      if (name) authorHtml = '<p class="author">' + escHtml(name) + '</p>';
    } else if (post.ente_curatore) {
      authorHtml = '<p class="author">' + escHtml(post.ente_curatore) + '</p>';
    }

    var tagLabel = post.tipo_di_post;

    var href = post.permalink;
    var linkAttrs = '';
    if (post.tipo_di_post === 'contributi') {
      if (post.contributo_video) {
        href = post.contributo_video;
        linkAttrs = ' data-fancybox=""';
      } else {
        href = 'javascript:;';
        linkAttrs = ' data-fancybox="" data-src="#contributo-' + post.id + '"';
      }
    }

    return '<a comp="tile-gallery" class="--list" href="' + href + '"' + linkAttrs + '>' +
      '<div class="tag-col">' +
        '<span comp="tags" class="--grey"><span>' + escHtml(tagLabel) + '</span></span>' +
      '</div>' +
      '<div class="list-body">' +
        '<div class="list-text">' +
          authorHtml +
          '<p class="title">' + escHtml(post.title) + '</p>' +
        '</div>' +
        '<span comp="button" class="--secondary"><span class="label">Scopri</span><span class="underline"></span></span>' +
      '</div>' +
    '</a>';
  }


  var init = function () {

    var root = document.querySelector('[comp="filtri-livello1"]');
    if (!root) { return; }

    var blogIdEl = document.querySelector('[data-blog-id]');
    var blogId = blogIdEl ? blogIdEl.getAttribute('data-blog-id') : null;
    var nonce = root.getAttribute('data-n') || '';

    // Override post_type via [data-post-types="progetti,contributi"] (es. template-gallery).
    // Fallback ai 3 tipi default su template-archivio-edizioni.
    var ptAttr = blogIdEl ? blogIdEl.getAttribute('data-post-types') : null;
    var ajaxPostTypes = ptAttr ? ptAttr.split(',').map(function(s){ return s.trim(); }).filter(Boolean) : ['progetti', 'eventi', 'contributi'];

    // ── Isotope / Packery init ──
    $container = $('#iso');
    $container.imagesLoaded(function () {
      $container.isotope({
        itemSelector: '.item',
        layoutMode: 'packery',
        packery: { gutter: 0 }
      });
    });

    // Panel → CSS class prefix mapping (used by getCurrentCombinedFilter and updateClearAllButton)
    var panelPrefixMap = {
      'panel-evento': 'sede-evento-',
      'panel-temi': 'temi-',
      'panel-promotori': 'promotore-',
      'panel-luoghi': 'luogo-',
      'panel-parolechiave': 'parolechiave-'
    };

    // ── Cascading filters (shared module) ──
    var cascade = UbpFiltriCascade.create({
      root: root,
      getItems: function () {
        if (!projects_data || !projects_data.posts || projects_data.posts.length === 0) {
          // Fallback: scan DOM items
          var items = [];
          document.querySelectorAll('#iso .item').forEach(function (el) {
            items.push({ classes: el.className, attrs: {} });
          });
          return items;
        }
        return projects_data.posts.map(function (p) {
          return {
            classes: typeof p.tile_classes === 'string' ? p.tile_classes : (p.tile_classes || []).join(' '),
            attrs: {},
            _post: p
          };
        });
      },
      panels: {
        'panel-evento': {
          matchFn: function (item, value) {
            return UbpFiltriCascade.hasClass(item.classes, 'sede-evento-' + value);
          }
        },
        'panel-temi': {
          matchFn: function (item, value) {
            return UbpFiltriCascade.hasClass(item.classes, 'temi-' + value);
          }
        },
        'panel-promotori': {
          matchFn: function (item, value) {
            return UbpFiltriCascade.hasClass(item.classes, 'promotore-' + value);
          }
        },
        'panel-luoghi': {
          matchFn: function (item, value) {
            return UbpFiltriCascade.hasClass(item.classes, 'luogo-' + value);
          }
        },
        'panel-parolechiave': {
          matchFn: function (item, value) {
            return UbpFiltriCascade.hasClass(item.classes, 'parolechiave-' + value);
          }
        }
      },
      barMatchFn: function (item, filterValue) {
        if (filterValue === '*') return true;
        var cls = filterValue.replace('.', '');
        return UbpFiltriCascade.hasClass(item.classes, cls);
      },
      itemFilter: function (item) {
        if (currentView === 'map') {
          if (UbpFiltriCascade.hasClass(item.classes, 'type-eventi')) return false;
          var p = item._post;
          if (p && (!p.locations || p.locations.length === 0)) return false;
        }
        return true;
      },
      onPanelChanged: function (panel) {
        updatePanelTags(panel);
      },
      onBarUpdate: function (activeWasHidden) {
        if (activeWasHidden) {
          applyAllFilters();
        }
        // Map button visibility
        var activeTypeBtn = root.querySelector('.btn[data-filter].--active');
        var activeTypeFilter = activeTypeBtn ? activeTypeBtn.getAttribute('data-filter') : '*';
        var hasEventi = root.querySelector('.btn[data-filter=".type-eventi"]');
        var hasProgetti = root.querySelector('.btn[data-filter=".type-progetti"]');
        var hasContributi = root.querySelector('.btn[data-filter=".type-contributi"]');
        var hasMapContent;
        if (activeTypeFilter === '.type-eventi') {
          hasMapContent = false;
        } else if (activeTypeFilter === '*') {
          hasMapContent = (hasProgetti && hasProgetti.style.display !== 'none') ||
                          (hasContributi && hasContributi.style.display !== 'none');
        } else {
          hasMapContent = true;
        }
        var mapBtn = root.querySelector('.view-btn[data-view="map"]');
        if (mapBtn) {
          if (hasMapContent) {
            mapBtn.style.display = '';
          } else {
            mapBtn.style.display = 'none';
            if (currentView === 'map') {
              mapBtn.classList.remove('--active');
              var gridBtn = root.querySelector('.view-btn[data-view="grid"]');
              if (gridBtn) {
                gridBtn.classList.add('--active');
                gridBtn.click();
              }
            }
          }
        }
        updateClearAllButton();
      }
    });

    // Initial cascade
    cascade.update();


    // ── Content type filter ──
    root.querySelectorAll('.btn[data-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Toggle active state
        root.querySelectorAll('.btn[data-filter]').forEach(function (b) {
          b.classList.remove('--active');
        });
        this.classList.add('--active');

        var filterVal = this.getAttribute('data-filter');

        // Update cascading filters for new type (may remove panel items)
        cascade.update();

        // Apply combined filter (type + panels)
        var combinedFilter = getCurrentCombinedFilter();
        $container.isotope({ filter: combinedFilter });
        $('.iso-list').isotope({ filter: combinedFilter });

        // Map sync with combined filter
        if ($('#projects-map').hasClass('active') && projects_data.posts) {
          var mapData = filterProjectsData(combinedFilter);
          LayoutMappa.mappa(mapData, 'filter');
        }
      });
    });


    // ── View toggle ──
    root.querySelectorAll('.view-btn[data-view]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('.view-btn').forEach(function (b) {
          b.classList.remove('--active');
        });
        this.classList.add('--active');

        var view = this.getAttribute('data-view');
        currentView = view;

        if (view === 'grid') {
          $('#projects-map').height(0).removeClass('active');
          $('#content > #lista').hide();
          $container.show();
          setTimeout(function () { $container.isotope('layout'); }, 50);
          // Recalculate cascading filters for grid context (all post types)
          cascade.update();
        }

        if (view === 'list') {
          $('#projects-map').height(0).removeClass('active');
          $container.hide();
          var $lista = $('#content > #lista');
          $lista.show();
          var $isoList = $('.iso-list');
          setTimeout(function () {
            if ($isoList.data('isotope')) {
              $isoList.isotope('layout');
            } else {
              $isoList.isotope({
                itemSelector: '.iso-item',
                layoutMode: 'fitRows'
              });
            }
          }, 50);
          // Recalculate cascading filters for list context (all post types)
          cascade.update();
        }

        if (view === 'map') {
          var showMap = function () {
            var $map = $('#projects-map');

            // Size map container
            $map.removeClass('d-none');
            var containerW = $('#content').width();
            var windowH = $(window).height();
            var adminBarH = $('#wpadminbar').length ? 32 : 0;
            $map.width(containerW).height(windowH - adminBarH - 200);

            // Init map if not already
            if (!LayoutMappa.isInit || !LayoutMappa.isInit()) {
              LayoutMappa.mapInit();
            }

            $map.addClass('active').attr('data-status', '1');

            setTimeout(function () {
              // Apply current filters to map data
              var currentFilter = getCurrentCombinedFilter();
              var mapData = filterProjectsData(currentFilter);
              LayoutMappa.mappa(mapData, 'viewToggle');
            }, 300);

            $container.hide();
            $('#content > #lista').hide();

            // Recalculate cascading filters for map context (only mappable posts)
            cascade.update();
            cascade.update();
          };

          // Only fetch data if we don't have it yet
          if (projects_data && projects_data.posts && projects_data.posts.length > 0) {
            showMap();
          } else {
            loadProjectData(showMap, true);
          }
        }
      });
    });


    // ── Dropdown panel toggle ──
    root.querySelectorAll('.dropdown[data-panel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panelId = this.getAttribute('data-panel');
        var panel = document.getElementById(panelId);
        if (!panel) { return; }

        var wasOpen = !panel.hidden;

        // Close all panels
        root.querySelectorAll('[comp="filtri-pannello"]').forEach(function (p) {
          p.hidden = true;
        });
        root.querySelectorAll('.dropdown').forEach(function (d) {
          d.classList.remove('is-open');
        });

        // Toggle current
        if (!wasOpen) {
          panel.hidden = false;
          this.classList.add('is-open');
        }
      });
    });

    // Close panels on click outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[comp="filtri-livello1"]')) {
        root.querySelectorAll('[comp="filtri-pannello"]').forEach(function (p) {
          p.hidden = true;
        });
        root.querySelectorAll('.dropdown').forEach(function (d) {
          d.classList.remove('is-open');
        });
      }
    });


    // ── Panel search ──
    document.querySelectorAll('[comp="filtri-pannello"] .search input').forEach(function (input) {
      input.addEventListener('keyup', function () {
        var query = this.value.toLowerCase();
        var panel = this.closest('[comp="filtri-pannello"]');
        panel.querySelectorAll('.grid-item').forEach(function (item) {
          var text = item.textContent.toLowerCase();
          item.style.display = text.indexOf(query) !== -1 ? '' : 'none';
        });
      });
    });


    // ── Panel item selection ──
    root.querySelectorAll('[comp="filtri-pannello"]').forEach(function (panel) {
      var panelId = panel.id;
      var isEdition = panelId === 'panel-edizioni';
      var selectMode = panel.getAttribute('data-select-mode') || 'multiple';

      panel.querySelectorAll('.grid-item').forEach(function (item) {
        item.addEventListener('click', function () {
          if (selectMode === 'single') {
            // Single: deselect others, select this (toggle off if already selected)
            var wasSelected = this.classList.contains('--selected');
            panel.querySelectorAll('.grid-item').forEach(function (gi) {
              gi.classList.remove('--selected');
            });
            if (!wasSelected) {
              this.classList.add('--selected');
            }

            // Update dropdown label
            var ddBtn = root.querySelector('.dropdown[data-panel="' + panelId + '"]');
            if (ddBtn) {
              var labelSpan = ddBtn.querySelector('.dropdown-label');
              var originalLabel = ddBtn.getAttribute('data-original-label');
              if (!originalLabel) {
                ddBtn.setAttribute('data-original-label', labelSpan.textContent);
                originalLabel = labelSpan.textContent;
              }
              labelSpan.textContent = wasSelected ? originalLabel : this.textContent.trim();
            }

            // Close panel
            panel.hidden = true;
            root.querySelectorAll('.dropdown').forEach(function (d) {
              d.classList.remove('is-open');
            });

            if (isEdition) {
              // Edition change — AJAX
              if (!wasSelected) {
                var edition = this.getAttribute('data-value');
                var newBlogId = UbpEdizioni.idEdizione(parseInt(edition));
                if (newBlogId) {
                  blogId = newBlogId;
                  if (blogIdEl) { blogIdEl.setAttribute('data-blog-id', blogId); }

                  // Reset content type to "All"
                  root.querySelectorAll('.btn[data-filter]').forEach(function (b) {
                    b.classList.remove('--active');
                  });
                  var allBtn = root.querySelector('.btn[data-filter="*"]');
                  if (allBtn) { allBtn.classList.add('--active'); }

                  loadProjectData(function () {
                    cascade.update();
                    updateClearAllButton();
                  });
                }
              } else {
                // Deselected edition — no action (keep current)
              }
            } else {
              // Non-edition single-select: apply filters
              applyAllFilters();
              cascade.update();
            }
          } else {
            // Multiple: toggle
            this.classList.toggle('--selected');
            updatePanelTags(panel);
            cascade.update();
          }
        });
      });

      // ── Panel "Reset" ──
      var resetBtn = panel.querySelector('.reset');
      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          panel.querySelectorAll('.grid-item.--selected').forEach(function (gi) {
            gi.classList.remove('--selected');
          });
          updatePanelTags(panel);
          if (!isEdition) {
            cascade.update();
          }
          panel.hidden = true;
          root.querySelectorAll('.dropdown').forEach(function (d) {
            d.classList.remove('is-open');
          });
        });
      }

      // ── Panel "Applica filtri" ──
      var applyBtn = panel.querySelector('[comp="button"]');
      if (applyBtn) {
        applyBtn.addEventListener('click', function (e) {
          e.preventDefault();

          if (isEdition) {
            // Edition change — AJAX
            var selectedItem = panel.querySelector('.grid-item.--selected');
            if (selectedItem) {
              var edition = selectedItem.getAttribute('data-value');
              var newBlogId = UbpEdizioni.idEdizione(parseInt(edition));
              if (newBlogId) {
                blogId = newBlogId;
                if (blogIdEl) { blogIdEl.setAttribute('data-blog-id', blogId); }

                // Reset content type to "All"
                root.querySelectorAll('.btn[data-filter]').forEach(function (b) {
                  b.classList.remove('--active');
                });
                var allBtn = root.querySelector('.btn[data-filter="*"]');
                if (allBtn) { allBtn.classList.add('--active'); }

                loadProjectData(function () {
                  cascade.update();
                  cascade.update();
                  updateClearAllButton();
                });
              }
            }
          } else {
            applyAllFilters();
          }

          // Close panel
          panel.hidden = true;
          root.querySelectorAll('.dropdown').forEach(function (d) {
            d.classList.remove('is-open');
          });
        });
      }
    });


    // ── "Cancella tutti i filtri" button ──
    var clearAllBtn = root.querySelector('.clear-all');
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', function () {
        // Reset all filter panels (not editions)
        var panelIds = Object.keys(panelPrefixMap);
        panelIds.forEach(function (pid) {
          var panel = document.getElementById(pid);
          if (!panel) { return; }
          panel.querySelectorAll('.grid-item.--selected').forEach(function (gi) {
            gi.classList.remove('--selected');
          });
          updatePanelTags(panel);
        });

        // Reset content type to "All"
        root.querySelectorAll('.btn[data-filter]').forEach(function (b) {
          b.classList.remove('--active');
        });
        var allBtn = root.querySelector('.btn[data-filter="*"]');
        if (allBtn) { allBtn.classList.add('--active'); }

        // Close open panels
        root.querySelectorAll('[comp="filtri-pannello"]').forEach(function (p) {
          p.hidden = true;
        });
        root.querySelectorAll('.dropdown').forEach(function (d) {
          d.classList.remove('is-open');
        });

        // Apply
        applyAllFilters();
        cascade.update();
      });
    }


    // ── Update panel tags ──
    function updatePanelTags(panel) {
      var tagsContainer = panel.querySelector('.tags');
      if (!tagsContainer) { return; }
      tagsContainer.innerHTML = '';

      panel.querySelectorAll('.grid-item.--selected').forEach(function (item) {
        var tag = document.createElement('button');
        tag.type = 'button';
        tag.className = 'tag';
        tag.innerHTML = item.textContent + ' <span class="material-symbols-outlined">close_small</span>';
        tag.addEventListener('click', function () {
          item.classList.remove('--selected');
          updatePanelTags(panel);
          if (panel.id !== 'panel-edizioni') {
            cascade.update();
          }
        });
        tagsContainer.appendChild(tag);
      });

      // Update dropdown count
      var panelId = panel.id;
      var ddBtn = root.querySelector('.dropdown[data-panel="' + panelId + '"]');
      if (ddBtn) {
        var count = panel.querySelectorAll('.grid-item.--selected').length;
        var countSpan = ddBtn.querySelector('.dropdown-count');
        if (count > 0) {
          ddBtn.classList.add('--has-count');
          if (!countSpan) {
            countSpan = document.createElement('span');
            countSpan.className = 'dropdown-count';
            ddBtn.querySelector('.dropdown-label').insertAdjacentElement('afterend', countSpan);
          }
          countSpan.textContent = '(' + count + ')';
        } else {
          ddBtn.classList.remove('--has-count');
          if (countSpan) { countSpan.remove(); }
        }
      }
    }


    // ── Build combined filter string from current selections ──
    function getCurrentCombinedFilter() {
      var panelPrefixes = {
        'panel-evento': '.sede-evento-',
        'panel-temi': '.temi-',
        'panel-promotori': '.promotore-',
        'panel-luoghi': '.luogo-',
        'panel-parolechiave': '.parolechiave-'
      };

      // Collect selections grouped by panel (each group = OR)
      var groups = [];
      Object.keys(panelPrefixes).forEach(function (pid) {
        var panel = document.getElementById(pid);
        if (panel) {
          var selected = [];
          panel.querySelectorAll('.grid-item.--selected').forEach(function (item) {
            selected.push(panelPrefixes[pid] + item.getAttribute('data-value'));
          });
          if (selected.length > 0) {
            groups.push(selected);
          }
        }
      });

      var activeTypeBtn = root.querySelector('.btn[data-filter].--active');
      var typeFilter = activeTypeBtn ? activeTypeBtn.getAttribute('data-filter') : '*';

      if (groups.length === 0) {
        return typeFilter;
      }

      // Cartesian product: AND between panels, OR within each panel
      // e.g. groups = [['.luogo-roma', '.luogo-firenze'], ['.temi-citta']]
      // result = '.luogo-roma.temi-citta, .luogo-firenze.temi-citta'
      var prefix = typeFilter !== '*' ? typeFilter : '';
      var combos = groups.reduce(function (acc, group) {
        var result = [];
        acc.forEach(function (prev) {
          group.forEach(function (sel) {
            result.push(prev + sel);
          });
        });
        return result;
      }, [prefix]);

      return combos.join(', ');
    }


    // ── Apply combined filters from all panels ──
    function applyAllFilters() {
      var combinedFilter = getCurrentCombinedFilter();

      $container.isotope({ filter: combinedFilter });
      $('.iso-list').isotope({ filter: combinedFilter });

      // Map sync — pass filtered data
      if ($('#projects-map').hasClass('active') && projects_data.posts) {
        var mapData = filterProjectsData(combinedFilter);
        LayoutMappa.mappa(mapData, 'filter');
      }

      updateClearAllButton();
    }


    // ── Filter projects_data by a combined Isotope selector ──
    // Supports comma-separated OR groups: ".a.b, .a.c" means (a AND b) OR (a AND c)
    function filterProjectsData(combinedFilter) {
      var filtered = jQuery.extend({}, projects_data);
      if (combinedFilter && combinedFilter !== '*') {
        var orGroups = combinedFilter.split(',').map(function (s) { return s.trim(); });
        filtered.posts = projects_data.posts.filter(function (p) {
          var cls = ' ' + (typeof p.tile_classes === 'string' ? p.tile_classes : (p.tile_classes || []).join(' ')) + ' ';
          return orGroups.some(function (group) {
            var parts = group.match(/\.[a-z0-9_-]+/gi) || [];
            return parts.every(function (part) {
              var needle = part.replace('.', '');
              return cls.indexOf(' ' + needle + ' ') !== -1;
            });
          });
        });
      }
      filtered.count = filtered.posts.length;
      return filtered;
    }


    // panelPrefixMap declared above cascade init


    // ── Update "Cancella tutti i filtri" button ──
    function updateClearAllButton() {
      var clearBtn = root.querySelector('.clear-all');
      if (!clearBtn) { return; }

      var totalCount = 0;
      var panelIds = Object.keys(panelPrefixMap);
      panelIds.forEach(function (pid) {
        var panel = document.getElementById(pid);
        if (panel) {
          totalCount += panel.querySelectorAll('.grid-item.--selected').length;
        }
      });

      if (totalCount > 0) {
        clearBtn.style.display = '';
        clearBtn.querySelector('.clear-count').textContent = '(' + totalCount + ')';
      } else {
        clearBtn.style.display = 'none';
      }
    }


    // ── Load project data via AJAX ──
    // fetchOnly: if true, only store data without rebuilding DOM
    function loadProjectData(callback, fetchOnly) {
      $.ajax({
        url: rw_ajax_obj.ajax_url,
        type: 'post',
        data: {
          action: 'ubp_load_posts',
          blog_id: blogId,
          post_type: ajaxPostTypes,
          order: 'id',
          _ajax_nonce: nonce
        },
        success: function (response) {
          var json = $.parseJSON(response);
          projects_data = json;

          var idEdizione = blogId;

          // Normalize tile_classes/list_classes to strings
          var posts = json.posts;
          for (var i = 0; i < posts.length; i++) {
            if (Array.isArray(posts[i].tile_classes)) {
              posts[i].tile_classes = posts[i].tile_classes.join(' ');
            }
            if (Array.isArray(posts[i].list_classes)) {
              posts[i].list_classes = posts[i].list_classes.join(' ');
            }
          }

          if (!fetchOnly) {
            // Update body class
            $('body').removeClass(function (index, className) {
              return (className.match(/(^|\s)site-\S+/g) || []).join(' ');
            }).addClass('site-' + blogId);

            // Rebuild grid tiles
            var outputgrid = '';
            var outputlist = '';

            for (var i = 0; i < posts.length; i++) {
              var tileClasses = posts[i].tile_classes;
              var listClasses = posts[i].list_classes;

              if (posts[i].tipo_di_post == 'eventi') {
                outputgrid += '<article class="' + tileClasses + '">' +
                  renderTileEvento(posts[i]) + '</article>';
              } else {
                outputgrid += '<article class="' + tileClasses + '">' +
                  renderTileGrid(posts[i]) + '</article>';
              }

              outputlist += '<div class="' + listClasses + '">' +
                renderTileList(posts[i]) + '</div>';
            }

            // Rebuild grid isotope
            var canvas_backup = $('#iso #grid_bck');
            if ($container.data('isotope')) {
              $container.isotope('destroy');
            }
            $container.html('').append(canvas_backup).append(outputgrid);
            $container.imagesLoaded(function () {
              $container.isotope({
                itemSelector: '.item',
                layoutMode: 'packery',
                packery: { gutter: 0 }
              });
            });

            // Rebuild list isotope
            var $isoList = $('.iso-list');
            if ($isoList.data('isotope')) {
              $isoList.isotope('destroy');
            }
            $isoList.html('').addClass('--gallery').append(outputlist);
            $isoList.imagesLoaded(function () {
              $isoList.isotope({
                itemSelector: '.iso-item',
                layoutMode: 'fitRows',
                filter: '*'
              });
            });

            // Update filter panels with new data
            updateFilterPanels(json);

            // Reload Love buttons
            if (typeof RwAjaxLove != 'undefined') {
              RwAjaxLove.start();
            }

            $('#projects-map').addClass('firstinit');
          }

          if (callback) { callback(); }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log('Errore: ' + textStatus, errorThrown);
        }
      });
    }


    // ── Update filter panels with AJAX data ──
    function updateFilterPanels(json) {
      // Update panel-evento
      rebuildPanelItems('panel-evento', json.titoloevento, function (t) {
        return { label: t.name, value: t.slug };
      });

      // Update panel-temi
      rebuildPanelItems('panel-temi', json.temi, function (t) {
        return { label: t.name, value: t.slug };
      });

      // Update panel-promotori
      rebuildPanelItems('panel-promotori', json.promotori, function (t) {
        return { label: t.name, value: t.slug };
      });

      // Update panel-luoghi
      rebuildPanelItems('panel-luoghi', json.luoghi, function (t) {
        return { label: t.name, value: t.slug };
      });

      // Update panel-parolechiave
      rebuildPanelItems('panel-parolechiave', json.parolechiave, function (t) {
        return { label: t.name, value: t.slug };
      });
    }


    // ── Helper: rebuild panel grid items ──
    function rebuildPanelItems(panelId, data, mapFn) {
      var panel = document.getElementById(panelId);
      if (!panel) { return; }

      var grid = panel.querySelector('.grid');
      if (!grid) { return; }

      // Hide dropdown if no data
      var ddBtn = root.querySelector('.dropdown[data-panel="' + panelId + '"]');

      if (!data || data.length === 0) {
        if (ddBtn) { ddBtn.style.display = 'none'; }
        grid.innerHTML = '';
        return;
      }

      if (ddBtn) { ddBtn.style.display = ''; }

      grid.innerHTML = '';
      data.forEach(function (item) {
        var mapped = mapFn(item);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'grid-item';
        btn.setAttribute('data-value', mapped.value);
        btn.textContent = mapped.label;
        btn.addEventListener('click', function () {
          this.classList.toggle('--selected');
          updatePanelTags(panel);
          cascade.update();
        });
        grid.appendChild(btn);
      });

      // Clear tags
      updatePanelTags(panel);
    }


    // ── Window resize ──
    var resizeTimer;
    $(window).resize(function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (currentView === 'grid') {
          $container.isotope('layout');
        } else if (currentView === 'list') {
          var $isoList = $('.iso-list');
          if ($isoList.data('isotope')) {
            $isoList.isotope('layout');
          }
        } else if (currentView === 'map') {
          var $map = $('#projects-map');
          if ($map.hasClass('active')) {
            var containerW = $('#content').width();
            var windowH = $(window).height();
            var adminBarH = $('#wpadminbar').length ? 32 : 0;
            $map.width(containerW).height(windowH - adminBarH - 200);
            if (typeof google !== 'undefined' && google.maps) {
              google.maps.event.trigger($map[0], 'resize');
            }
          }
        }
      }, 150);
    });


    // ───────────────────────────────────────────────────────────────────────
    // MOBILE: filter modal (Filtra per) + views bottom-sheet (.more)
    // I selettori usati esistono solo se il blocco filtri-livello1 li ha
    // renderizzati; tutto il codice è no-op se i nodi mancano.
    // ───────────────────────────────────────────────────────────────────────

    // Sposta i pannelli inline (subito dopo il dropdown corrispondente) quando
    // il modale è aperto; li rimette in .panels-container alla chiusura.
    function reorderPanelsInline() {
      root.querySelectorAll('.dropdowns .dropdown[data-panel]').forEach(function (dd) {
        var panel = document.getElementById(dd.getAttribute('data-panel'));
        if (panel && dd.parentNode) {
          dd.parentNode.insertBefore(panel, dd.nextSibling);
        }
      });
    }
    function restorePanelsToContainer() {
      var container = root.querySelector('.panels-container');
      if (!container) { return; }
      root.querySelectorAll('.dropdowns [comp="filtri-pannello"]').forEach(function (p) {
        container.appendChild(p);
      });
    }
    function openFilterModal() {
      reorderPanelsInline();
      root.classList.add('--modal-open');
    }
    function closeFilterModal() {
      root.classList.remove('--modal-open');
      // Chiudi pannelli e dropdowns aperti
      root.querySelectorAll('[comp="filtri-pannello"]').forEach(function (p) { p.hidden = true; });
      root.querySelectorAll('.dropdown.is-open').forEach(function (d) { d.classList.remove('is-open'); });
      restorePanelsToContainer();
    }

    var filterTrigger     = root.querySelector('.filter-trigger');
    var filterModalClose  = root.querySelector('.filter-modal-close');
    var filterModalApply  = root.querySelector('.filter-modal-apply');
    var filterModalReset  = root.querySelector('.filter-modal-reset');
    var triggerClear      = root.querySelector('.filter-trigger-clear');
    var triggerClearCount = root.querySelector('.filter-trigger-clear-count');
    var clearAllBtnRef    = root.querySelector('.clear-all');

    // Sincronizza visibilità + count del pulsante "Cancella tutti i filtri" sul
    // trigger row mobile con lo stato di .clear-all (gestito da updateClearAllButton).
    function syncTriggerClear() {
      if (!clearAllBtnRef || !triggerClear) { return; }
      var visible = clearAllBtnRef.style.display !== 'none';
      triggerClear.hidden = !visible;
      if (visible && triggerClearCount) {
        var countEl = clearAllBtnRef.querySelector('.clear-count');
        triggerClearCount.textContent = countEl ? countEl.textContent : '';
      }
    }
    if (clearAllBtnRef && triggerClear) {
      syncTriggerClear();
      var triggerClearObs = new MutationObserver(syncTriggerClear);
      triggerClearObs.observe(clearAllBtnRef, {
        attributes: true,
        attributeFilter: ['style'],
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    if (triggerClear && clearAllBtnRef) {
      triggerClear.addEventListener('click', function () {
        clearAllBtnRef.click();
      });
    }

    if (filterTrigger) {
      filterTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        openFilterModal();
      });
    }
    if (filterModalClose) {
      filterModalClose.addEventListener('click', function () { closeFilterModal(); });
    }
    if (filterModalApply) {
      filterModalApply.addEventListener('click', function () {
        // Riusa la logica esistente: il click sull'Applica di un pannello multi
        // chiama applyAllFilters() (funzione locale a init, non esposta).
        var panelApply = root.querySelector('[comp="filtri-pannello"] [comp="button"]');
        if (panelApply) { panelApply.click(); }
        closeFilterModal();
      });
    }
    if (filterModalReset) {
      filterModalReset.addEventListener('click', function () {
        var clearAllBtn = root.querySelector('.clear-all');
        if (clearAllBtn) { clearAllBtn.click(); } // funziona anche se display:none
        closeFilterModal();
      });
    }

    // Bottom-sheet views: toggle via .more
    var moreBtn = root.querySelector('.bar .more');
    if (moreBtn) {
      moreBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        root.classList.toggle('--views-open');
      });
    }

    // Click fuori dal bottom-sheet → chiudi
    document.addEventListener('click', function (e) {
      if (!root.classList.contains('--views-open')) { return; }
      if (e.target.closest('.views-sheet') || e.target.closest('.bar .more')) { return; }
      root.classList.remove('--views-open');
    });

    // Selezione di una vista nel bottom-sheet → propaga al .view-btn corrispondente
    root.querySelectorAll('.views-sheet-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var mode = this.getAttribute('data-view');
        // Sync stato attivo (sheet + view-btn desktop)
        root.querySelectorAll('.views-sheet-option').forEach(function (b) {
          b.classList.toggle('--active', b.getAttribute('data-view') === mode);
        });
        root.querySelectorAll('.view-btn').forEach(function (b) {
          b.classList.toggle('--active', b.getAttribute('data-view') === mode);
        });
        // Inoltra il click al .view-btn (se ha un handler che cambia la vista)
        var viewBtn = root.querySelector('.view-btn[data-view="' + mode + '"]');
        if (viewBtn) { viewBtn.click(); }
        root.classList.remove('--views-open');
      });
    });


  }; // end init


  return {
    init: init
  };

})();
